import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { translateError } from 'app/lib/error';
import { Snackbar, SnackbarMessage, SnackbarVariant } from 'app/components/core/Snackbar';
import { DefaultErrorPropType } from 'app/lib/proptypes';

export const DeployTransformationFailedNotification = ({ id, onDismiss, error }) => {
    const { t } = useTranslation();

    let message = t('deployTransformation:notifications.errorPrefix') + translateError(t, error);
    if (error && error.errorMessage === 'SQL execution canceled' && error.table) {
        message += t('deployTransformation:notifications.errorSuffix', { table: error.table });
    }

    return (
        <Snackbar
            onDismiss={onDismiss}
            id={id}
            variant={SnackbarVariant.ERROR}
            enableShowDetailsIfTruncated
            message={message}>
            <SnackbarMessage>{message}</SnackbarMessage>
        </Snackbar>
    );
};

DeployTransformationFailedNotification.propTypes = {
    id: PropTypes.string.isRequired,
    onDismiss: PropTypes.func.isRequired,
    error: DefaultErrorPropType.isRequired
};
